<container-element [ngSwitch]="type">
    <ng-container *ngSwitchCase="'checkbox'">
        <div class="form-check mb-3">
            <input [formControlName]="controlName" class="form-check-input" type="checkbox"
                [id]="'input-' + controlName">
            <label class="form-check-label" [for]="'input-' + controlName">
                {{label}}
            </label>
        </div>
    </ng-container>
    <ng-container *ngSwitchCase="'textarea'">
        <div class="form-label-group">
            <div class="input-group mb-3">
                <textarea [formControlName]="controlName" class="form-control" [id]="'input-' + controlName" rows="3"
                    [attr.disabled]="disabled ? '' : null"
                    (ngModelChange)="modelChange(this)" [ngClass]="classList" [ngStyle]="inputStyle"></textarea>
                <label [for]="'input-' + controlName">{{label}}</label>
                <div class="invalid-feedback">
                    <ng-container *ngIf="getField()?.errors?.required">
                        {{label}} obrigatório
                    </ng-container>
                </div>
            </div>
        </div>
    </ng-container>
    <ng-container *ngSwitchDefault>
        <div class="form-label-group">
            <div class="input-group mb-3">
                <ng-container *ngIf="!list">
                    <ng-container *ngIf="!prefix">
                        <input [formControlName]="controlName" [type]="type" [id]="'input-' + controlName"
                            class="form-control" [placeholder]="label" autocomplete="off" [mask]="mask" (keyup.enter)="clickEnter()"
                            [attr.disabled]="disabled ? '' : null"
                            [minlength]="minlength" [maxlength]="maxlength" (ngModelChange)="modelChange(this)"
                            [patterns]="customPattern" [ngClass]="classList" [ngStyle]="inputStyle">
                    </ng-container>
                    <ng-container *ngIf="prefix">
                        <input [formControlName]="controlName" [type]="type" [id]="'input-' + controlName"
                            class="form-control" [placeholder]="label" autocomplete="off" [mask]="mask" (keyup.enter)="clickEnter()"
                            [attr.disabled]="disabled ? '' : null"
                            [prefix]="prefix" [dropSpecialCharacters]="dropSpecialCharacters"
                            [showMaskTyped]="showMaskTyped" [minlength]="minlength" [maxlength]="maxlength"
                            (ngModelChange)="modelChange(this)" [patterns]="customPattern"
                            [ngClass]="classList" [ngStyle]="inputStyle">
                    </ng-container>

                </ng-container>
                <ng-container *ngIf="list">
                  <ng-container *ngIf="!autofill">
                    <select (change)="valueChange()" [formControlName]="controlName" [id]="'input-' + controlName"
                        [attr.disabled]="disabled ? '' : null"
                        class="form-control" autocomplete="off" [ngClass]="classList" [ngStyle]="inputStyle">
                        <option *ngIf="selecione" [value]="null">- Selecione -</option>
                        <ng-container *ngFor="let item of list">
                            <option [value]="item[listValue]">{{item[listText]}}</option>
                        </ng-container>
                    </select>
                  </ng-container>
                  <ng-container *ngIf="autofill">
                      <input
                        [formControlName]="controlName"
                        [type]="type"
                        [id]="'input-' + controlName"
                        class="form-control"
                        [placeholder]="label"
                        autocomplete="off"
                        [attr.disabled]="disabled ? '' : null"
                        [attr.list]="'datalist-' + controlName"
                        [ngClass]="classList"
                        [ngStyle]="inputStyle"
                        (keyup.enter)="clickEnter()"
                        (ngModelChange)="modelChange(this)"
                      />
                      <datalist [id]="'datalist-' + controlName">
                        <option *ngFor="let item of list" [value]="item[listValue] || item[listText]">
                          {{ item[listText] }}
                        </option>
                      </datalist>
                  </ng-container>
                </ng-container>

                <i *ngIf="help" class="bi bi-info-circle-fill i-help" [popover]="help" popoverTitle="Ajuda"
                    popoverPlacement="top" [popoverOnHover]="true" [popoverCloseOnClickOutside]="true"
                    [popoverCloseOnMouseOutside]="false" [popoverDisabled]="false" [popoverAnimation]="true"></i>
                <label [for]="'input-' + controlName">{{label}}</label>
                <div class="invalid-feedback">
                    <ng-container *ngIf="getField()?.errors?.required">
                        {{label}} obrigatório
                    </ng-container>
                    <ng-container *ngIf="getField()?.errors?.pattern">
                      <ng-container *ngIf="type === 'password'; else patternGeneric">
                        A senha deve conter letras, números e caracteres especiais.
                      </ng-container>
                      <ng-template #patternGeneric>
                        {{ label }} incorreto
                      </ng-template>
                    </ng-container>
                    <ng-container *ngIf="getField()?.errors?.minlength && minlength > 0">
                        Mínimo de {{getField()?.errors?.minlength.requiredLength}} caracateres
                    </ng-container>
                    <ng-container *ngIf="getField()?.errors?.maxlength">
                        Máximo de {{getField()?.errors?.maxlength.requiredLength}} caracateres
                    </ng-container>
                    <ng-container *ngIf="getField()?.errors?.digit || getField()?.errors?.length">
                        Documento incorreto
                    </ng-container>
                    <ng-container *ngIf="getField()?.errors?.mask">
                        formato incorreto
                    </ng-container>
                </div>
            </div>
        </div>
    </ng-container>
</container-element>
